export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const GET_CONFIG = 'GET_CONFIG';
